import React, { useState, useEffect, useReducer } from 'react';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { Select } from '../../../../../../_metronic/_partials/controls';
import Numeric from '../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../redux/my-axios';
import ImageGallery from 'react-image-gallery';
import {
  productStatusList,
  productTypeList,
  initialEditorContent,
} from '../ProductsUIHelpers';
import css from './style.module.css';

import CheckBox from '../../../../../components/CheckBox';
import { Button } from '@material-ui/core';

const PARAM_URL = '/params';
const url = `${baseUrl}/product-image-upload`;

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        productCode: action.payload.productCode,
        typeCode: action.payload.typeCode,
        categoryCode: action.payload.categoryCode,
        brandCode: action.payload.brandCode,
        shortName: action.payload.shortName,
        name: action.payload.name,
        color: action.payload.color,
        sizeValue: action.payload.sizeValue,
        weight: parseFloat(action.payload.weight),
        count: Number(action.payload.count),
        reserveCount: Number(action.payload.reserveCount),
        bundleCount: Number(action.payload.bundleCount),
        orderedCount: Number(action.payload.orderedCount),
        saleOrderedCount: Number(action.payload.saleOrderedCount),
        status: action.payload.status,
        price: parseFloat(action.payload.price),
        salePrice: parseFloat(action.payload.salePrice),
        cost: parseFloat(action.payload.cost),
        margin: parseFloat(action.payload.margin),
        withGift: action.payload.withGift === 1 ? true : false,
        isPublish: action.payload.isPublish === 1 ? true : false,
        icon: action.payload.icon,
        images: action.payload.images,
        imageList: action.payload.imageList,
        useColor: action.payload.useColor,
        useSize: action.payload.useSize,
        details: action.payload.details,
      };
    case 'setTypeCode':
      return { ...state, typeCode: action.payload };
    case 'setCategoryCode':
      return { ...state, categoryCode: action.payload };
    case 'setBrandCode':
      return { ...state, brandCode: action.payload };
    case 'setShortName':
      return { ...state, shortName: action.payload };
    case 'setName':
      return { ...state, name: action.payload };
    case 'setColor':
      return { ...state, color: action.payload };
    case 'setSizeValue':
      return { ...state, sizeValue: action.payload };
    case 'setWeight':
      return { ...state, weight: parseFloat(action.payload) };
    case 'setCount':
      return { ...state, count: Number(action.payload) };
    case 'setReserveCount':
      var diff = state.reserveCount - Number(action.payload);
      return {
        ...state,
        reserveCount: Number(action.payload),
        count: state.count + diff,
      };
    case 'setPrice':
      return { ...state, price: parseFloat(action.payload) };
    case 'setSalePrice':
      return { ...state, salePrice: parseFloat(action.payload) };
    case 'setCost':
      return { ...state, cost: parseFloat(action.payload) };
    case 'setIcon':
      return { ...state, icon: action.payload };
    case 'setImages':
      return {
        ...state,
        images: JSON.stringify(action.payload),
        imageList: action.payload,
      };
    case 'setUseColor':
      return { ...state, useColor: action.payload };
    case 'setUseSize':
      return { ...state, useSize: action.payload };
    case 'calcMargin':
      return {
        ...state,
        margin: (state.price - state.cost) / state.price,
      };
    case 'setWithGift':
      return { ...state, withGift: action.payload };
    case 'setIsPublish':
      return { ...state, isPublish: action.payload };
    case 'setDetails':
      return { ...state, details: action.payload };
    default:
      console.log('Wrong actionType:', action);
  }
}

const ProductViewForm = (props) => {
  const {
    intl,
    actionsLoading,
    info,
    error,
    productForView,
    initialProduct,
    btnRefSave,
    newClick,
    btnRefNew,
    saveProduct,
    onHide,
  } = props;
  // States
  const [state, dispatch] = useReducer(reducer, initialProduct);
  const [err, setErr] = useState();
  const [msg, setMsg] = useState();
  const [websiteList, setWebsiteList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(actionsLoading);

  // Messages
  const MIN_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MIN_LENGTH',
  });
  const MAX_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MAX_LENGTH',
  });
  const REQUIRED = intl.formatMessage({
    id: 'GENERAL.VALIDATION.REQUIRED',
  });
  const ProductCreateSchema = Yup.object().shape({
    typeCode: Yup.string().required(REQUIRED),
    categoryCode: Yup.string().required(REQUIRED),
    brandCode: Yup.string().required(REQUIRED),
    shortName: Yup.string()
      .required(REQUIRED)
      .min(1, MIN_LENGTH.replace('#value#', '1'))
      .max(10, MAX_LENGTH.replace('#value#', '10')),
    name: Yup.string()
      .required(REQUIRED)
      .min(1, MIN_LENGTH.replace('#value#', '1'))
      .max(200, MAX_LENGTH.replace('#value#', '200')),
  });

  useEffect(() => {
    //console.log('ProductForView', productForView);
    dispatch({ type: 'init', payload: productForView });
    /* if (productForView.details) {
      setEditorState(
        EditorState.createWithContent(
          convertFromRaw(JSON.parse(productForView.details))
        )
      ); 
    } else {
      setEditorState(EditorState.createEmpty());
    } */
  }, [productForView]);
  useEffect(() => {
    const storeKeyCategory = 'categoryList';
    let listCategory = undefined;
    if (categoryList !== []) {
      //listCategory = localStorage.getItem(storeKeyCategory);
      if (listCategory) {
        setCategoryList(JSON.parse(listCategory));
      } else {
        axios
          .post(PARAM_URL, 'getcategorylist', {
            headers: { action: 'getcategorylist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setCategoryList(response.data.data);
                localStorage.setItem(
                  storeKeyCategory,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
      }
    } else {
      listCategory = localStorage.getItem(storeKeyCategory);
      if (!listCategory) {
        // LocalStorage-s setleh
        localStorage.setItem(storeKeyCategory, JSON.stringify(categoryList));
      }
      setLoaded(true);
    }

    const storeKeyBrand = 'brandList';
    let listBrand = undefined;
    if (brandList !== []) {
      //listBrand = localStorage.getItem(storeKeyBrand);
      if (listBrand) {
        setBrandList(JSON.parse(listBrand));
      } else {
        axios
          .post(PARAM_URL, 'getbrandlist', {
            headers: { action: 'getbrandlist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setBrandList(response.data.data);
                localStorage.setItem(
                  storeKeyBrand,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
      }
    } else {
      listBrand = localStorage.getItem(storeKeyBrand);
      if (!listBrand) {
        // LocalStorage-s setleh
        localStorage.setItem(storeKeyBrand, JSON.stringify(brandList));
      }
      setLoaded(true);
    }

    const storeKeyWebsite = 'websiteList';
    let listWebsite = undefined;
    if (websiteList !== []) {
      //listWebsite = localStorage.getItem(storeKeyWebsite);
      if (listWebsite) {
        setWebsiteList(JSON.parse(listWebsite));
      } else {
        axios
          .post(PARAM_URL, 'getwebsitelist', {
            headers: { action: 'getwebsitelist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setWebsiteList(response.data.data);
                localStorage.setItem(
                  storeKeyWebsite,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
      }
    } else {
      listWebsite = localStorage.getItem(storeKeyWebsite);
      if (!listWebsite) {
        localStorage.setItem(storeKeyWebsite, JSON.stringify(websiteList));
      }
      setLoaded(true);
    }

    return function cleanup() {
      setWebsiteList([]);
      setCategoryList([]);
      setBrandList([]);
    };
  }, [loaded]);

  useEffect(() => {
    setMsg('');
    setErr(error);
  }, [error]);
  useEffect(() => {
    setErr('');
    setMsg(info);
  }, [info]);
  useEffect(() => {
    setLoading(actionsLoading);
  }, [actionsLoading]);
  /*   useEffect(() => {
    console.log('State', state);
  }, [state]); */

  const save = (values) => {
    console.log('Save:', values);
    let icon;
    if (values.imageList && values.imageList.length > 0)
      icon = JSON.parse(values.imageList[0]).thumbnail;
    saveProduct({
      ...values,
      images: JSON.stringify(values.imageList),
      icon,
      useSize: values.useSize ? 1 : 0,
      useColor: values.useColor ? 1 : 0,
      isPublish: values.isPublish ? 1 : 0,
      withGift: values.withGift ? 1 : 0,
      details: values.details,
    });
  };

  const create = () => {
    if (
      productForView.categoryCode != state.categoryCode ||
      productForView.brandCode != state.brandCode ||
      productForView.typeCode != state.typeCode ||
      productForView.shortName != state.shortName ||
      productForView.name != state.name ||
      productForView.color != state.color ||
      productForView.weight != state.weight ||
      productForView.sizeValue != state.sizeValue ||
      productForView.count != state.count ||
      productForView.reserveCount != state.reserveCount ||
      productForView.margin != state.margin ||
      productForView.price != state.price ||
      productForView.salePrice != state.salePrice ||
      productForView.useSize != state.useSize ||
      productForView.useColor != state.useColor ||
      productForView.details != state.details
    ) {
      setMsg('');
      setErr('Өөрчлөлтөө хадгална уу!');
    } else {
      setErr('');
      newClick();
    }
  };

  const setCategoryCode = (categoryCode) => {
    dispatch({ type: 'setCategoryCode', payload: categoryCode });
  };
  const setBrandCode = (brandCode) => {
    dispatch({ type: 'setBrandCode', payload: brandCode });
  };
  function setTypeCode(typeCode) {
    dispatch({ type: 'setTypeCode', payload: typeCode });
  }
  const setShortName = (shortName) => {
    dispatch({ type: 'setShortName', payload: shortName });
  };
  const setName = (name) => {
    dispatch({ type: 'setName', payload: name });
  };
  const setImagelist = (imageList) => {
    dispatch({ type: 'setImages', payload: imageList });
  };
  const setColor = (color) => {
    dispatch({ type: 'setColor', payload: color });
  };
  const setSizeValue = (sizeValue) => {
    dispatch({ type: 'setSizeValue', payload: sizeValue });
  };
  const setPrice = (price) => {
    dispatch({ type: 'setPrice', payload: price });
    dispatch({ type: 'calcMargin', payload: '' });
  };
  const setSalePrice = (salePrice) => {
    dispatch({ type: 'setSalePrice', payload: salePrice });
  };
  const setCount = (count) => {
    dispatch({ type: 'setCount', payload: count });
  };
  const setReserveCount = (reserveCount) => {
    dispatch({ type: 'setReserveCount', payload: reserveCount });
  };

  const setWithGift = (withGift) => {
    dispatch({ type: 'setWithGift', payload: withGift });
  };
  const setIsPublish = (isPublish) => {
    dispatch({ type: 'setIsPublish', payload: isPublish });
  };
  const setUseSize = (useSize) => {
    dispatch({ type: 'setUseSize', payload: useSize });
  };
  const setUseColor = (useColor) => {
    dispatch({ type: 'setUseColor', payload: useColor });
  };
  const setStatus = (status) => {
    dispatch({ type: 'setStatus', payload: status });
  };
  const setWeight = (weight) => {
    dispatch({ type: 'setWeight', payload: weight });
  };
  const setDetails = (details) => {
    dispatch({ type: 'setDetails', payload: details });
  };
  const setCost = (cost) => {
    dispatch({ type: 'setCost', payload: cost });
    dispatch({ type: 'calcMargin', payload: '' });
  };

  const getImages = ({ id, pictures }) => {
    if (!pictures) return [];
    let temp = [];
    if (pictures && pictures.length > 0) {
      pictures.forEach((el) => {
        let e = JSON.parse(el);
        let t = {
          original: `${baseUrl}/product-image-download?id=${id}&file=${e.original}`,
          thumbnail: `${baseUrl}/product-image-download?id=${id}&file=${e.thumbnail}`,
        };
        temp.push(t);
      });
      return temp;
    }
    return [];
  };

  const onProductImagesChange = (event) => {
    const files = Array.from(event.target.files);
    const formData = new FormData();

    files.forEach((file) => {
      if (file.size > 1024 * 1024 * 20) {
        alert('Зургийн хэмжээ их байна. 20MB -с хэтрэхгүй байх!');
        return;
      }
      formData.append(file.name, file);
    });
    setLoading(true);

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        id: state.productCode,
      },
      /*       headers: {
        'Content-Type': 'multipart/form-data; ',
      }, */
    })
      .then((response) => response.json())
      .then((result) => {
        //console.log('onProductImagesChange:', result);
        switch (result.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            setImagelist(result.data);
            //setProductPhotos(result.data);
            //setImages(result.data);
            break;
          default:
            // setErr(result.data.msg.desc);
            break;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        // setErr(error);
      });
    setLoading(false);
    //console.log('uploaded', productPhotos);
  };

  function getCategoryName(option) {
    var t = '';
    for (var i = 0; i < option.extra; i++) t = t + `...`;
    return t + option.name;
  }
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={state}
        validationSchema={ProductCreateSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({ errors, touched, handleBlur, isValidating }) => (
          <>
            <Form className='form form-label-right' size='sm'>
              {err ? (
                <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{err}</div>
                </div>
              ) : (
                <div></div>
              )}
              {msg ? (
                <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{msg}</div>
                </div>
              ) : (
                <div></div>
              )}
              <div className='form-group row'>
                <div
                  className='col-4'
                  /*                     style={{
                      height: '350px',
                      borderStyle: 'dashed',
                      borderColor: 'gray',
                    }} */
                >
                  <div
                    style={{
                      borderStyle: 'solid',
                      borderWidth: '1px',
                      borderColor: 'lightgray',
                      borderRadius: '5%',
                      justifyItems: 'center',
                      alignContent: 'center',
                      textAlign: 'center',
                      height: '330px',
                    }}
                  >
                    {state.imageList && state.imageList.length > 0 ? (
                      <ImageGallery
                        items={getImages({
                          id: state.productCode,
                          pictures: state.imageList,
                        })}
                      />
                    ) : (
                      <div />
                    )}
                    <label htmlFor='contained-button-file-product'>
                      <input
                        accept='image/*'
                        style={{ display: 'none' }}
                        id='contained-button-file-product'
                        type='file'
                        onChange={onProductImagesChange}
                        multiple
                      />
                      <label htmlFor='contained-button-file-product'>
                        {state.productCode ? (
                          <Button
                            variant='contained'
                            component='span'
                            className='btn btn-light btn-elevate'
                          >
                            Зураг оруулах
                          </Button>
                        ) : (
                          <></>
                        )}
                      </label>
                    </label>
                  </div>
                </div>
                <div className='col-8'>
                  <div className='form-group row'>
                    <div className='col-3'>
                      <Select
                        name='typeCode'
                        className='form-control'
                        onChange={(e) => {
                          setTypeCode(e.target.value);
                        }}
                        disabled={state.productCode}
                      >
                        {productTypeList.map((option) => (
                          <option
                            key={`productTypeListDetail${option.code}`}
                            value={option.code}
                          >
                            {option.name}
                          </option>
                        ))}
                      </Select>
                      {errors.typeCode && touched.typeCode ? (
                        <div>{errors.typeCode}</div>
                      ) : null}
                    </div>
                    <div className='col-3'>
                      <Select
                        name='categoryCode'
                        className='form-control'
                        onChange={(e) => {
                          setCategoryCode(e.target.value);
                        }}
                      >
                        {categoryList.map((option) => (
                          <option
                            key={`categoryListDetail${option.code}`}
                            value={option.code}
                          >
                            {getCategoryName(option)}
                          </option>
                        ))}
                      </Select>
                      {errors.categoryCode && touched.categoryCode ? (
                        <div>{errors.categoryCode}</div>
                      ) : null}
                    </div>
                    <div className='col-3'>
                      <Select
                        name='brandCode'
                        className='form-control'
                        placeholder='Брэнд сонгох'
                        onChange={(e) => {
                          setBrandCode(e.target.value);
                        }}
                        disabled={state.productCode}
                      >
                        {brandList.map((option) => (
                          <option
                            key={`brandListDetail${option.code}`}
                            value={option.code}
                          >
                            {option.name}
                          </option>
                        ))}
                      </Select>
                      {errors.brandCode && touched.brandCode ? (
                        <div>{errors.brandCode}</div>
                      ) : null}
                    </div>
                    <div className='col-3'>
                      <Field
                        name='shortName'
                        className='form-control'
                        placeholder='Товч нэр'
                        onBlur={(e) => {
                          setShortName(e.target.value);
                        }}
                        disabled={state.productCode}
                      />
                      {errors.shortName && touched.shortName ? (
                        <div>{errors.shortName}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-12'>
                      <Field
                        name='name'
                        className='form-control'
                        placeholder='Нэр'
                        onBlur={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      {errors.name && touched.name ? (
                        <div>{errors.name}</div>
                      ) : null}
                    </div>
                  </div>
                  <div
                    className='form-group row'
                    /*  style={{
                        display: 'inline-flex',
                        textAlign: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }} */
                  >
                    <div className='col-3'>
                      <Field
                        name='sizeValue'
                        className='form-control'
                        placeholder='Хэмжээ'
                        onBlur={(e) => {
                          setSizeValue(e.target.value);
                        }}
                      />
                      {!state.productCode && (
                        <CheckBox
                          text='кодонд оруулах'
                          checked={state.useSize}
                          changeCheckBoxValue={setUseSize}
                        />
                      )}
                    </div>
                    <div className='col-3'>
                      <Field
                        name='color'
                        className='form-control'
                        placeholder='Өнгө'
                        onBlur={(e) => {
                          setColor(e.target.value);
                        }}
                      />
                      {!state.productCode && (
                        <CheckBox
                          text='кодонд оруулах'
                          checked={state.useColor}
                          changeCheckBoxValue={setUseColor}
                        />
                      )}
                    </div>
                    <div className='col-3'>
                      <Numeric
                        name='weight'
                        value={state.weight}
                        onChange={setWeight}
                        className='form-control'
                        negative={false}
                      />
                      <small>Жин</small>
                    </div>
                    <div className='col-3'>
                      <CheckBox
                        id='isPublish'
                        text='Зарах эсэх'
                        checked={state.isPublish}
                        changeCheckBoxValue={setIsPublish}
                      />
                      <CheckBox
                        id='withGift'
                        text='Бэлэгтэй эсэх'
                        checked={state.withGift}
                        changeCheckBoxValue={setWithGift}
                      />
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-3'>
                      <Numeric
                        name='price'
                        value={state.price}
                        onChange={setPrice}
                        className='form-control'
                        negative={false}
                      />
                      <small>Үнэ</small>
                    </div>
                    <div className='col-3'>
                      <Numeric
                        name='salePrice'
                        value={state.salePrice}
                        onChange={setSalePrice}
                        className='form-control'
                        negative={false}
                      />
                      <small>Хямдрах үнэ</small>
                    </div>
                    <div className='col-3'>
                      <Numeric
                        name='cost'
                        value={state.cost}
                        className='form-control'
                        onChange={setCost}
                      />
                      <small>Нийт өртөг</small>
                    </div>
                    <div className='col-3'>
                      <Numeric
                        name='margin'
                        value={state.margin}
                        className='form-control'
                        disabled={true}
                      />
                      <small>Ашгийн хувь</small>
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-3'>
                      <Numeric
                        name='count'
                        value={state.count}
                        className='form-control'
                        onChange={setCount}
                        negative={true}
                        decimalScale='0'
                        fixedDecimalScale={false}
                        type='number'
                      />
                      <small>Бэлэн тоо ширхэг</small>
                    </div>
                    <div className='col-3'>
                      <Numeric
                        name='reserveCount'
                        value={state.reserveCount}
                        className='form-control'
                        onChange={setReserveCount}
                        negative={false}
                        decimalScale='0'
                        fixedDecimalScale={false}
                        type='number'
                      />
                      <small>Нөөцөлсөн</small>
                    </div>
                    <div className='col-2'>
                      <Numeric
                        name='bundleCount'
                        value={state.bundleCount}
                        className='form-control'
                        negative={false}
                        decimalScale='0'
                        fixedDecimalScale={false}
                        type='number'
                        disabled={true}
                      />
                      <small>Багцлагдсан</small>
                    </div>
                    <div className='col-2'>
                      <Numeric
                        name='orderedCount'
                        value={state.orderedCount}
                        className='form-control'
                        negative={false}
                        decimalScale='0'
                        fixedDecimalScale={false}
                        type='number'
                        disabled={true}
                      />
                      <small>Захиалсан</small>
                    </div>
                    <div className='col-2'>
                      <Numeric
                        name='saleOrderedCount'
                        value={state.saleOrderedCount}
                        className='form-control'
                        negative={false}
                        decimalScale='0'
                        fixedDecimalScale={false}
                        type='number'
                        disabled={true}
                      />
                      <small>Захиалга</small>
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-3'>
                      <Select
                        name='status'
                        className='form-control'
                        onChange={(e) => {
                          setStatus(e.target.value);
                        }}
                      >
                        {productStatusList.map((option) => (
                          <option
                            key={`productStatusList${option.code}`}
                            value={option.code}
                          >
                            {option.name}
                          </option>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-12'>
                      <Field
                        name='details'
                        className='form-control form-control-sm'
                        placeholder='Тайлбар'
                        as='textarea'
                        rows='5'
                        onBlur={(e) => {
                          setDetails(e.target.value);
                        }}
                      />
                      {/*  <Editor
                        //initialContentState={contentState}
                        //onContentStateChange={setContentState}
                        editorState={editorState}
                        onEditorStateChange={onEditorStateChange}
                        toolbarClassName='toolbar-class'
                        wrapperClassName='wrapper-class'
                        editorClassName='editor-class'
                      /> */}
                    </div>
                  </div>
                </div>
              </div>

              <button
                type='submit'
                style={{ display: 'none' }}
                ref={btnRefSave}
              ></button>
              <button
                type='button'
                style={{ display: 'none' }}
                ref={btnRefNew}
                onClick={() => create()}
              ></button>
              <button
                type='button'
                onClick={onHide}
                style={{ display: 'none' }}
              >
                cancel
              </button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default injectIntl(ProductViewForm);
